import {navigate} from 'gatsby';
import * as React from 'react';
import {useEffect, useState} from 'react';

import ILocation from '../../_typescript/interfaces/ILocation';
import IProfileUser from '../../_typescript/interfaces/IProfileUser';
import AnchorScroll from '../../components/AnchorScroll/AnchorScroll';
import IconLink from '../../components/IconLink/IconLink';
import Layout from '../../components/Layout/Layout';
import {getAuthUser, logout} from '../../helpers/user';
import {fetchUser} from '../../project_api/user';
// @ts-ignore
import * as profileStyles from './profile.module.css';

interface IProfilePage {
    location: ILocation;
}

const ProfilePage = ({location,}: IProfilePage) => {
    const [user, setUser,] = useState(null as null | IProfileUser);

    useEffect(() => {
        (async () => {
            await fetchUser();
            const user = await getAuthUser();
            if (!user) {
                navigate('/user/login');
                return;
            }
            setUser(user);
        })();
    }, []);

    if (!user) {
        return null;
    }

    return (
        <AnchorScroll>
            <Layout location={location}>
                <div className="grid-2--mobile grid-8--tablet grid-12--desktop">
                    <section>
                        <div className={`grid-8--desktop grid-offset-2--desktop ${profileStyles.form}`}>
                            <h3>CALLWEY PROFIL</h3>
                            <h1>von {user.name}</h1>

                            <div>
                                <IconLink
                                    layout="button"
                                    backgroundInformation="backgroundIsBlack"
                                    onClick={async () => {
                                        await logout();
                                    }}
                                    label="Abmelden"
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </Layout>
        </AnchorScroll>
    );
};
export default ProfilePage;
